import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { NEEDS_PASSWORD_KEY } from "./app/auth";
import "./styles.css";

// Links de convite e de recuperação de senha chegam com "type=invite|recovery" no hash.
// Guardamos isso ANTES de o SDK do Supabase ler e limpar o hash, para pedir a definição de senha.
try {
  const type = new URLSearchParams(window.location.hash.slice(1)).get("type");
  if (type === "invite" || type === "recovery") sessionStorage.setItem(NEEDS_PASSWORD_KEY, "1");
} catch {
  /* sem armazenamento: segue normalmente */
}

const root = document.getElementById("root");
if (!root) throw new Error("Elemento #root não encontrado");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// PWA (Fase 7): só em produção. Guarda a casca do app; a API nunca é guardada em cache.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err: unknown) => {
      console.warn("Service worker não registrado:", err);
    });
  });
}
